// extracted by mini-css-extract-plugin
export default {"content":"Manual_content__wugwN","manual__container":"Manual_manual__container__CvvNF","manual__pdf":"Manual_manual__pdf__3dD51"};